import { countRows, superSyncLog } from "../../utils/superSyncLog";
const isStaleAreaResponse = (state, action) => {
  const responseAreaId = action.meta?.area_id;
  const currentAreaId = state.currentShop?.area_id;

  if (responseAreaId === undefined || responseAreaId === null || responseAreaId === "") return false;
  if (currentAreaId === undefined || currentAreaId === null || currentAreaId === "") return false;

  const stale = String(responseAreaId) !== String(currentAreaId);

  if (stale) {
    superSyncLog(action.meta?.syncId, "STALE_AREA_RESPONSE_IGNORED", {
      actionType: action.type,
      responseAreaId,
      currentAreaId,
      responseCount: countRows(action.payload),
    });
  }

  return stale;
};

const patchRowsById = (rows = [], idField, id, updates) =>
  (rows || []).map((row) =>
    String(row?.[idField] ?? "") === String(id ?? "")
      ? { ...row, ...updates }
      : row
  );

const customSortCompanyName = (a, b) => {
  const companyA = (a.company_name || "").toLowerCase();
  const companyB = (b.company_name || "").toLowerCase();

  let comparison = 0;
  if (companyA > companyB) comparison = 1;
  else if (companyA < companyB) comparison = -1;
  return comparison;
};

/*
PROMJENA
*/
const initState = {
  retail: [],
  retailX: [],
  resto: [],
  restoK: [],
  currentCompany: { id: -1, shops: [], filteredShops: [], direct: false },
  currentShop: {
    payments: [],
    paymentsDeferred: [],          // ✅ deferred payments
    taxes: [],
    categories: [],
    categoriesDeferred: [],        // ✅ deferred categories
    categoriesMulti: [],
    reports: [],
    categoriesRound: [],
    less: [],
    other: [],
    imports: [],
    importsPO: [],
    type: "RETAIL",
  },
  currentReports: [], // added 4.9.2024
  loadingTables: {},
  retailCategoriesByShop: {},
};

const databaseReducer = (state = initState, action) => {
  switch (action.type) {
    case "SET_TABLE_LOADING":
      return {
        ...state,
        loadingTables: {
          ...state.loadingTables,
          [action.payload.key]: action.payload.value,
        },
      };

    case "CLEAR_CURRENT_REPORTS":
      return {
        ...state,
        currentReports: [],
      };

    case "CLEAR_CURRENT_SHOP":
      return {
        ...state,
        currentShop: {
          payments: [],
          paymentsDeferred: [],     // ✅ reset
          taxes: [],
          categories: [],
          categoriesDeferred: [],   // ✅ reset
          categoriesMulti: [],
          reports: [],
          categoriesFree: [],
          categoriesRound: [],
          less: [],
          other: [],
          imports: [],
          importsPO: [],
          shop_id: null,
          area_id: null,
        },
      };

    case "SET_RETAIL":
      return { ...state, retail: (action.payload || []).sort(customSortCompanyName) };

    case "SET_RETAILX":
      return { ...state, retailX: (action.payload || []).sort(customSortCompanyName) };

    case "SET_RESTO":
      return { ...state, resto: (action.payload || []).sort(customSortCompanyName) };

    case "SET_RESTOK":
      superSyncLog(action.meta?.syncId, "REDUCER_SET_RESTOK_LIST", { responseCount: countRows(action.payload) });
      return { ...state, restoK: (action.payload || []).sort(customSortCompanyName) };

    case "SET_CURRENT_RETAIL":
      return {
        ...state,
        currentCompany: {
          shops: action.payload.currentRetail,
          filteredShops: action.payload.currentRetail,
          id: action.payload.id,
          direct: false,
          type: "RETAIL",
          INTEGRATION_NAME:
            action.payload.companyMeta?.INTEGRATION_NAME ??
            action.payload.companyMeta?.integration_name ??
            null,
          integration_name:
            action.payload.companyMeta?.integration_name ??
            action.payload.companyMeta?.INTEGRATION_NAME ??
            null,
        },
        currentShop: {
          ...action.payload.currentRetail[0],
          payments: [],
          paymentsDeferred: [],     // ✅ reset
          taxes: [],
          categories: [],
          categoriesDeferred: [],   // ✅ reset
          categoriesMulti: [],
          reports: [],
          categoriesFree: [],
          categoriesRound: [],
          less: [],
          other: [],
          imports: [],
          importsPO: [],
        },
      };

    case "SET_CURRENT_RETAILX":
      return {
        ...state,
        currentCompany: {
          shops: action.payload.currentRetail,
          filteredShops: action.payload.currentRetail,
          id: action.payload.id,
          direct: false,
          type: "RETAILX",
        },
        currentShop: {
          ...action.payload.currentRetail[0],
          payments: [],
          paymentsDeferred: [],     // ✅ reset
          taxes: [],
          categories: [],
          categoriesDeferred: [],   // ✅ reset
          categoriesMulti: [],
          reports: [],
          categoriesFree: [],
          categoriesRound: [],
          less: [],
          other: [],
          imports: [],
          importsPO: [],
        },
      };

    case "SET_CURRENT_SHOP_IMPORT":
      return {
        ...state,
        currentShop: { ...state.currentShop, imports: action.payload },
      };

    case "SET_CURRENT_SHOP_IMPORT_PO":
      return {
        ...state,
        currentShop: { ...state.currentShop, importsPO: action.payload },
      };

    case "SET_CURRENT_RESTO":
      return {
        ...state,
        currentCompany: {
          direct: action.payload.currentResto.length === 0 ? true : false,
          shops: action.payload.currentResto,
          filteredShops: action.payload.currentResto,
          id: action.payload.id,
          type: "RESTO",
        },
        currentShop: {
          ...action.payload.currentResto[0],
          payments: [],
          paymentsDeferred: [],     // ✅ reset
          taxes: [],
          categories: [],
          categoriesDeferred: [],   // ✅ reset
          categoriesMulti: [],
          reports: [],
          categoriesRound: [],
          less: [],
          other: [],
          imports: [],
          importsPO: [],
        },
      };

    case "SET_CURRENT_RESTOK": {
      const areas = action.payload.currentRestoK || [];
      const sameCompany = String(state.currentCompany.id) === String(action.payload.id);
      const currentAreaId = String(state.currentShop.area_id ?? "");
      const selectedArea =
        (sameCompany && areas.find((area) => String(area.area_id ?? "") === currentAreaId)) ||
        areas[0] ||
        {};
      const sameArea = String(state.currentShop.area_id ?? "") === String(selectedArea.area_id ?? "");
      const keepCurrentTabData = sameCompany && sameArea;
      superSyncLog(action.meta?.syncId, "REDUCER_SET_CURRENT_RESTOK", {
        responseAreas: countRows(areas),
        previousAreaId: state.currentShop.area_id,
        selectedAreaId: selectedArea.area_id,
        sameCompany,
        sameArea,
        keepCurrentTabData,
        previousCounts: {
          payments: countRows(state.currentShop.payments),
          categories: countRows(state.currentShop.categories),
          other: countRows(state.currentShop.other),
          taxes: countRows(state.currentShop.taxes),
        },
      });

      return {
        ...state,
        currentCompany: {
          direct: action.payload.currentRestoK.length === 0 ? true : false,
          shops: action.payload.currentRestoK,
          filteredShops: action.payload.currentRestoK,
          id: action.payload.id,
          type: "RESTOK",
          INTEGRATION_NAME:
            action.payload.companyMeta?.INTEGRATION_NAME ??
            action.payload.companyMeta?.integration_name ??
            null,
          integration_name:
            action.payload.companyMeta?.integration_name ??
            action.payload.companyMeta?.INTEGRATION_NAME ??
            null,
        },
        currentShop: {
          ...selectedArea,
          payments: keepCurrentTabData ? state.currentShop.payments : [],
          paymentsDeferred: keepCurrentTabData ? state.currentShop.paymentsDeferred : [],
          taxes: keepCurrentTabData ? state.currentShop.taxes : [],
          categories: keepCurrentTabData ? state.currentShop.categories : [],
          categoriesDeferred: keepCurrentTabData ? state.currentShop.categoriesDeferred : [],
          categoriesMulti: keepCurrentTabData ? state.currentShop.categoriesMulti : [],
          reports: keepCurrentTabData ? state.currentShop.reports : [],
          categoriesRound: keepCurrentTabData ? state.currentShop.categoriesRound : [],
          less: keepCurrentTabData ? state.currentShop.less : [],
          other: keepCurrentTabData ? state.currentShop.other : [],
          imports: keepCurrentTabData ? state.currentShop.imports : [],
        },
      };
    }

    case "SET_CURRENT_FILTERED_RETAL_RESTO_SHOPS":
      return {
        ...state,
        currentCompany: {
          ...state.currentCompany,
          filteredShops: state.currentCompany.shops.filter((item) => {
            if (item.area_name) {
              return item.area_name.toLowerCase().indexOf(action.payload.toLowerCase()) > -1;
            }
            return item.shop_name.toLowerCase().indexOf(action.payload.toLowerCase()) > -1;
          }),
        },
      };

    case "SET_CURRENT_RESTO_DIRECT":
      return {
        ...state,
        currentCompany: {
          ...state.currentCompany,
          direct: action.payload,
        },
      };

    // =========================
    // PAYMENTS
    // =========================
    case "SET_CURRENT_SHOP_PAYMENTS":
      return {
        ...state,
        currentShop: { ...state.currentShop, payments: action.payload },
      };

    case "SET_SHOP_PAYMENTS_DEFERRED":
      return {
        ...state,
        currentShop: { ...state.currentShop, paymentsDeferred: action.payload },
      };

    case "SET_CURRENT_SHOPX_PAYMENTS":
      return {
        ...state,
        currentShop: { ...state.currentShop, payments: action.payload },
      };

    // =========================
    // TAXES
    // =========================
    case "SET_CURRENT_SHOP_TAXES":
      return {
        ...state,
        currentShop: { ...state.currentShop, taxes: action.payload },
      };

    case "SET_CURRENT_SHOPX_TAXES":
      return {
        ...state,
        currentShop: { ...state.currentShop, taxes: action.payload },
      };

    // =========================
    // REPORT
    // =========================
    case "SET_CURRENT_SHOP_REPORT":
      return {
        ...state,
        currentShop: { ...state.currentShop, reports: action.payload },
      };

    // =========================
    // CATEGORIES
    // =========================
    case "SET_CURRENT_SHOP_CATEGORIES":
      return {
        ...state,
        currentShop: { ...state.currentShop, categories: action.payload },
        retailCategoriesByShop:
          action.meta?.shop_id && Array.isArray(action.payload) && action.payload.length
            ? {
                ...(state.retailCategoriesByShop || {}),
                [String(action.meta.shop_id)]: action.payload,
              }
            : state.retailCategoriesByShop || {},
      };

    case "SET_SHOP_CATEGORIES_DEFERRED": // ✅ NEW
      return {
        ...state,
        currentShop: { ...state.currentShop, categoriesDeferred: action.payload },
      };

    case "SET_CURRENT_SHOP_CATEGORIES_MULTI":
      return {
        ...state,
        currentShop: {
          ...state.currentShop,
          categoriesMulti: action.payload.cards,
        },
      };

    case "SET_CURRENT_SHOP_CATEGORIES_MULTI_FREE":
      return {
        ...state,
        currentShop: {
          ...state.currentShop,
          categoriesFree: action.payload,
        },
      };

    case "SET_CURRENT_SHOP_CATEGORIES_ROUND":
      return {
        ...state,
        currentShop: { ...state.currentShop, categoriesRound: action.payload },
      };

    case "SET_CURRENT_SHOP_CATEGORIES_OTHER":
      return {
        ...state,
        currentShop: { ...state.currentShop, other: action.payload },
      };

    case "SET_CURRENT_SHOPX_CATEGORIES_OTHER":
      return {
        ...state,
        currentShop: { ...state.currentShop, other: action.payload },
      };

    case "SET_CURRENT_SHOP_CATEGORIES_LESS":
      return {
        ...state,
        currentShop: { ...state.currentShop, less: action.payload },
      };

    case "SET_CURRENT_SHOPX_CATEGORIES":
      return {
        ...state,
        currentShop: { ...state.currentShop, categories: action.payload },
      };

    case "SET_CURRENT_SHOPX_CATEGORIES_MULTI":
      return {
        ...state,
        currentShop: {
          ...state.currentShop,
          categoriesMulti: action.payload.cards,
        },
      };

    case "SET_CURRENT_SHOPX_CATEGORIES_MULTI_FREE":
      return {
        ...state,
        currentShop: {
          ...state.currentShop,
          categoriesFree: action.payload,
        },
      };

    case "SET_CURRENT_SHOPX_CATEGORIES_ROUND":
      return {
        ...state,
        currentShop: { ...state.currentShop, categoriesRound: action.payload },
      };

    case "SET_CURRENT_SHOPX_CATEGORIES_LESS":
      return {
        ...state,
        currentShop: { ...state.currentShop, less: action.payload },
      };

    // =========================
    // AREA
    // =========================
    case "SET_CURRENT_AREA_PAYMENTS":
      if (isStaleAreaResponse(state, action)) return state;
      superSyncLog(action.meta?.syncId, "AREA_PAYMENTS_REDUCER_APPLY", {
        areaId: action.meta?.area_id,
        responseCount: countRows(action.payload),
        currentAreaId: state.currentShop.area_id,
      });
      return {
        ...state,
        loadingTables: { ...state.loadingTables, payments: false },
        currentShop: {
          ...state.currentShop,
          payments: action.payload,
        },
      };

    case "PATCH_CURRENT_AREA_PAYMENT":
      return {
        ...state,
        currentShop: {
          ...state.currentShop,
          payments: patchRowsById(
            state.currentShop.payments,
            "paymenttype_id",
            action.payload.paymenttype_id,
            action.payload.updates
          ),
        },
      };

    case "SET_CURRENT_AREA_TAXES":
      if (isStaleAreaResponse(state, action)) return state;
      superSyncLog(action.meta?.syncId, "AREA_TAXES_REDUCER_APPLY", {
        areaId: action.meta?.area_id,
        responseCount: countRows(action.payload),
        currentAreaId: state.currentShop.area_id,
      });
      return {
        ...state,
        loadingTables: { ...state.loadingTables, taxes: false },
        currentShop: {
          ...state.currentShop,
          taxes: action.payload,
        },
      };

    case "SET_CURRENT_AREA_CATEGORIES":
      if (isStaleAreaResponse(state, action)) return state;
      superSyncLog(action.meta?.syncId, "AREA_CATEGORIES_REDUCER_APPLY", {
        areaId: action.meta?.area_id,
        responseCount: countRows(action.payload),
        currentAreaId: state.currentShop.area_id,
      });
      return {
        ...state,
        loadingTables: { ...state.loadingTables, categories: false },
        currentShop: {
          ...state.currentShop,
          categories: action.payload,
        },
      };

    case "PATCH_CURRENT_AREA_CATEGORY":
      return {
        ...state,
        currentShop: {
          ...state.currentShop,
          categories: patchRowsById(
            state.currentShop.categories,
            "category_id",
            action.payload.category_id,
            action.payload.updates
          ),
        },
      };

    case "SET_CURRENT_AREA_CATEGORIESK":
      if (isStaleAreaResponse(state, action)) return state;
      superSyncLog(action.meta?.syncId, "AREA_CATEGORIESK_REDUCER_APPLY", {
        areaId: action.meta?.area_id,
        responseCount: countRows(action.payload),
        currentAreaId: state.currentShop.area_id,
      });
      return {
        ...state,
        loadingTables: { ...state.loadingTables, categories: false },
        currentShop: {
          ...state.currentShop,
          categories: action.payload,
        },
      };

    case "SET_CURRENT_AREA_CATEGORIES_OTHER":
      if (isStaleAreaResponse(state, action)) return state;
      superSyncLog(action.meta?.syncId, "AREA_OTHER_REDUCER_APPLY", {
        areaId: action.meta?.area_id,
        responseCount: countRows(action.payload),
        currentAreaId: state.currentShop.area_id,
      });
      return {
        ...state,
        loadingTables: { ...state.loadingTables, other: false },
        currentShop: {
          ...state.currentShop,
          other: action.payload,
        },
      };

    // =========================
    // IDS / META
    // =========================
    case "SET_CURRENT_COMPANY_ID":
      return {
        ...state,
        currentCompany: {
          ...state.currentCompany,
          id: action.payload,
        },
      };

    case "SET_CURRENT_SHOP_ID":
      return {
        ...state,
        currentShop: {
          ...state.currentShop,
          shop_id: action.payload,
          imports: [],
          importsPO: [],
        },
      };

    case "SET_CURRENT_SHOP_IDX":
      return {
        ...state,
        currentShop: {
          ...state.currentShop,
          shop_id: action.payload,
          imports: [],
          importsPO: [],
        },
      };

    case "SET_CURRENT_COMPANY_TYPE":
      return {
        ...state,
        currentCompany: { ...state.currentCompany, type: action.payload },
      };

    case "SET_CURRENT_COMPANY_INTEGRATION_NAME":
      return {
        ...state,
        currentCompany: {
          ...state.currentCompany,
          INTEGRATION_NAME: action.payload,
          integration_name: action.payload,
        },
      };

    case "SET_CURRENT_SHOP_COMPANY_ID":
      return {
        ...state,
        currentCompany: { ...state.currentCompany, id: action.payload },
        currentShop: {
          ...state.currentShop,
          company_id: action.payload,
        },
      };

    case "SET_CURRENT_SHOPX_COMPANY_ID":
      return {
        ...state,
        currentCompany: { ...state.currentCompany, id: action.payload },
        currentShop: {
          ...state.currentShop,
          company_id: action.payload,
        },
      };

    case "SET_CURRENT_AREA_ID":
      return {
        ...state,
        currentShop: {
          ...state.currentShop,
          area_id: action.payload,
          imports: [],
          importsPO: [],
        },
      };

    default:
      return state;
  }
};

export default databaseReducer;
